import { render, staticRenderFns } from "./editarEnvio.vue?vue&type=template&id=07d1b89a"
import script from "./editarEnvio.vue?vue&type=script&lang=ts"
export * from "./editarEnvio.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports